document.addEventListener('DOMContentLoaded', function () {

  // Countdown săptămânal - se resetează automat în fiecare duminică la 23:59:59
  function getEndOfWeek() {
    var now = new Date();
    var day = now.getDay(); // 0 = duminică, 1 = luni ... 6 = sâmbătă
    var daysUntilSunday = (7 - day) % 7;
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilSunday, 23, 59, 59);
    // dacă e duminică după 23:59:59 (caz limită), sari la duminica următoare
    if (end <= now) {
      end.setDate(end.getDate() + 7);
    }
    return end;
  }

  function updateCountdown() {
    var now = new Date();
    var endDate = getEndOfWeek();
    var diff = Math.max(0, endDate - now) / 1000;
    var d = Math.floor(diff / 86400);
    var h = Math.floor((diff % 86400) / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = Math.floor(diff % 60);
    var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
    var dEl = document.getElementById('fc-cd-d');
    var hEl = document.getElementById('fc-cd-h');
    var mEl = document.getElementById('fc-cd-m');
    var sEl = document.getElementById('fc-cd-s');
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);

   // Fade in/out la scroll
  var hero = document.querySelector('.fc-hero');
  var heroHeight = hero ? hero.offsetHeight : 0;

  window.addEventListener('scroll', function () {
    if (!hero) return;
    var scrolled = window.scrollY;
    var fadeStart = heroHeight * 0.5;

    if (scrolled > fadeStart) {
      hero.classList.add('is-fading');
    } else {
      hero.classList.remove('is-fading');
    }
  });

  // Slideshows
  var slideshows = document.querySelectorAll('.fc-slideshow');
  slideshows.forEach(function (ss) {
    var slot = ss.dataset.slot;
    var slides = ss.querySelectorAll('.fc-slide');
    var dots = document.querySelectorAll('.fc-hero__dots[data-for="' + slot + '"] .fc-dot');
    var current = 0;

    if (slides.length <= 1) return;

    setInterval(function () {
      slides[current].classList.remove('active');
      dots[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
      dots[current].classList.add('active');
    }, 3000);
  });

});